import React from "react";
import { Box, Toolbar } from "@mui/material";
import SideMenuBar from "./SideMenuBar";
import { AppBarHeader } from "./header/AppBarHeader";
import { Outlet } from "react-router-dom";

function MainDash() {
  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex", backgroundColor: "#F7F9FC", minHeight: "100vh" }}>
      <AppBarHeader open={open} handleDrawerOpen={handleDrawerOpen} />
      <SideMenuBar open={open} setOpen={setOpen} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          backgroundColor: "#F7F9FC",
          pt: "70px",
          pb: 4,
          px: { xs: 2, sm: 3, md: 4 },
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            maxWidth: "1440px",
            margin: "0 auto",
            pt: 3,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default MainDash;
